import { NgModule } from '@angular/core';
import { LoginComponent } from './@theme/components/login/login.component';
import { UserProfileComponent } from './@theme/components/user-profile/user-profile.component';
import {
  ResetPasswordComponent,
  ResetPasswordTokenComponent
} from './@theme/components';
import { SharedModule, createTranslateLoader } from './shared.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    LoginComponent,
    ResetPasswordComponent,
    ResetPasswordTokenComponent,
    UserProfileComponent
  ],
  entryComponents: [UserProfileComponent],
  imports: [
    SharedModule,
    FormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
  ]
})
export class UserModule {}
